module.exports = __webpack_public_path__ + "static/img/heavy_fire_scorpion.cb21ad6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/heavy_fire_scorpion.png
// module id = bj0m
// module chunks = 0